export const EVENT_FETCH = 'EVENT_FETCH'
export const EVENT_CREATE = 'EVENT_CREATE'
export const EVENT_UPDATE = 'EVENT_UPDATE'
export const EVENT_ANALYTICS = 'EVENT_ANALYTICS'
